import { GlobalStore } from '@mobx/stores/global-store';
import { createContext, ReactNode, useContext } from 'react';

const GlobalStoreContext = createContext<GlobalStore | undefined>(undefined);

const globalStore: GlobalStore = new GlobalStore();

export function GlobalStoreProvider(props: { children?: ReactNode }) {
    return (
        <GlobalStoreContext.Provider value={globalStore}>
            {props.children}
        </GlobalStoreContext.Provider>
    );
}

export function useGlobalStore() {
    const store = useContext(GlobalStoreContext);
    if (!store) {
        throw new Error('You have forgot to use Provider');
    }
    return store;
}
